import firebase from 'firebase'
import config from './firebase-config.json'
import store from '../store/index'
import {migrationListActions, userActions} from '../actions/index'
firebase.initializeApp(config);

firebase.database().ref('migrations')
    .on('value', snapshot => {
        const migrations = snapshot.val() || {}
        store.dispatch(migrationListActions.updateMigrationsList(Object.values(migrations)))
    })

firebase.auth().onAuthStateChanged(user => {
    store.dispatch(userActions.updateUser(user))
})

export const deleteMigration = id => {
    return firebase.database().ref(`migrations/${id}`).remove()
}


// WEBPACK FOOTER //
// ./src/js/firebase/firebase-manager.js